// pages/Products.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductComponents/ProductCard";
import ProductHero from "../components/ProductComponents/ProductHero";
import ProcessSection from "../components/ProductComponents/ProcessSection";
import CTASection from "../components/ProductComponents/CTASection";
import ProductFilters from "../components/ProductComponents/ProductFilters";

// Import images
import Yellow from "../assets/images/Yellow-vase.png";
import Popye from "../assets/images/popye-bust.png";
import coaster from "../assets/images/Customize-t-coster.png";
import Instagram from "../assets/images/Instagram-scanner.png";
import Gaint from "../assets/images/Gaint.png";
import Flowerblackvase from "../assets/images/Flower-blackvase.png";
import Flowerbluevase from "../assets/images/Flower-bluevase.png";
import Flowerredvase from "../assets/images/Flower-redvase.png";
import Joker from "../assets/images/Joker-bust.png";
import Customizeminiature from "../assets/images/Customize-Miniature.png";
import Blastoise from "../assets/images/Blastoise.png";
import Mashorrom from "../assets/images/Mashorrom.png";
import Moonnight from "../assets/images/Moonnight.png";
import messi from "../assets/images/messi.png";
import Doctorstrange from "../assets/images/Doctor-strange.png";
import Signboard from "../assets/images/Sign-board.png";
import Sdcard from "../assets/images/Sd-card.png";
import prathmesh from "../assets/images/Prathamesh.png";
import ins from "../assets/images/customized-keychain.png";
import keychains from "../assets/images/keychain.png";
import lithopane from "../assets/images/lithopane.png";
import snorlax from "../assets/images/Snorlax.png";
import bulbasaur from "../assets/images/Bualbasor.png";
import charmander from "../assets/images/Charmender.png";
import lapras from "../assets/images/Laparess.png";
import nineTails from "../assets/images/Nine-Tails.png";
import pikachu from "../assets/images/Pikachu.png";
import deadpool from "../assets/images/Deadpool.png";
import hulk from "../assets/images/Hulk.png";
import hulk_2 from "../assets/images/Hulk-2.png";
import jackSparrow from "../assets/images/Jack-Sparrow.png";
import blackPanther from "../assets/images/Black-Panther.png";
import Charmeleon from "../assets/images/Charmeleon.png";
import custom_name_keychain from "../assets/images/custom_name_keychain.png";
import Dragon from "../assets/images/Dragon.png";
import God_of_war from "../assets/images/God_of_war.png";
import Goku from "../assets/images/Goku.png";
import Loki from "../assets/images/Loki.png";
import Majinboo from "../assets/images/Majinboo.png";
import Naruto from "../assets/images/Naruto.png";
import Psyduck from "../assets/images/Psyduck.png";
import Ronaldo from "../assets/images/Ronaldo.png";
import Spiderman from "../assets/images/spiderman.png";
import Stitch from "../assets/images/Stitch.png";
import Superman from "../assets/images/Superman.png";
import Thor from "../assets/images/Thor.png";
import Vegeta from "../assets/images/Vegeta.png";
import card_holder from "../assets/images/Card_holder.jpg";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [sortBy, setSortBy] = useState("featured");
  const [loading, setLoading] = useState(true);
  const [visibleProducts, setVisibleProducts] = useState(6); // Initially show 6 products
  const PRODUCTS_PER_LOAD = 4; // Load 4 more products each time

  const whatsappNumber = "919158235932";

  // Categories for filtering
  const categories = [
    { id: "all", name: "All Products" },
    { id: "decorative", name: "Decorative" },
    { id: "functional", name: "Functional" },
    { id: "miniatures", name: "Miniatures" },
    { id: "custom", name: "Custom Projects" },
    { id: "pokemon", name: "Pokemon" },
    { id: "Marvel", name: "Marvel" },
    { id: "DragonBall", name: "Dragonball" },
  ];

  // Enhanced product data with multiple images
  useEffect(() => {
    const productsData = [
      {
        id: 1,
        title: "Flower Vase",
        price: "₹550",
        category: "decorative",
        images: [Yellow, Flowerblackvase, Flowerbluevase],
        description: "Elegant flower vase with modern geometric design.",
        features: [
          "Premium quality finish",
          "Multiple color options",
          "Durable material",
        ],
        inStock: true,
        discount: 10,
      },
      {
        id: 2,
        title: "Popeye Bust",
        price: "₹500",
        category: "miniatures",
        image: Popye,
        description: "Detailed Popeye character bust for collectors.",
        features: [
          "High detail finish",
          "Collector's item",
          "Perfect for display",
        ],
        inStock: true,
      },
      {
        id: 3,
        title: "Customized T-Coaster",
        price: "₹350",
        category: "decorative",
        image: coaster,
        description: "Personalized tea coaster set with custom designs.",
        features: ["Customizable design", "Heat resistant", "Set of 4"],
        inStock: true,
        originalPrice: "₹450",
      },
      {
        id: 4,
        title: "Instagram Scanner",
        price: "₹250",
        category: "functional",
        images: [Instagram, ins], // Multiple images for this product
        description: "QR code scanner display for social media.",
        features: [
          "Custom QR codes",
          "Multiple sizes available",
          "Durable material",
        ],
        inStock: true,
      },
      {
        id: 5,
        title: "Giant",
        price: "₹200",
        category: "miniatures",
        image: Gaint,
        description: "Large decorative piece for home or office.",
        features: ["Statement piece", "Lightweight design", "Easy to display"],
        inStock: true,
      },
      {
        id: 6,
        title: "Modern Flower Vase",
        price: "₹550",
        category: "decorative",
        image: Flowerblackvase,
        description: "Contemporary design flower vase.",
        features: ["Modern aesthetics", "Premium finish", "Multiple colors"],
        inStock: true,
      },
      {
        id: 7,
        title: "Abstract Flower Vase",
        price: "₹200",
        category: "decorative",
        image: Flowerbluevase,
        description: "Unique abstract design flower vase.",
        features: ["Artistic design", "Conversation piece", "Durable material"],
        inStock: true,
      },
      {
        id: 8,
        title: "Joker Bust",
        price: "₹450",
        category: "miniatures",
        image: Joker,
        description: "Detailed Joker character bust for collectors.",
        features: [
          "High detail finish",
          "Collector's item",
          "Perfect for display",
        ],
        inStock: true,
      },
      {
        id: 9,
        title: "Flower Vase (Red)",
        price: "₹400",
        category: "decorative",
        image: Flowerredvase,
        description:
          "High-quality standard 3D printing for all your creative needs.",
        features: [
          "Various materials available",
          "Standard resolution",
          "5-7 day turnaround",
        ],
        inStock: true,
      },
      {
        id: 10,
        title: "Customized Miniature",
        price: "From ₹800-₹1000",
        category: "custom",
        images: [prathmesh, Customizeminiature], // Multiple images for this product
        description: "Personalized miniature figures and models.",
        features: ["Custom design", "Various sizes", "Detailed finish"],
        inStock: true,
      },
      {
        id: 11,
        title: "Mushroom Container",
        price: "₹550",
        category: "functional",
        image: Mashorrom,
        description: "Decorative container with mushroom design.",
        features: ["Functional storage", "Unique design", "Multiple colors"],
        inStock: true,
      },
      {
        id: 12,
        title: "Moon Night Lamp",
        price: "₹900",
        category: "Marvel",
        image: Moonnight,
        description: "Realistic moon night lamp with stand.",
        features: [
          "LED lighting",
          "Realistic texture",
          "Multiple brightness levels",
        ],
        inStock: true,
      },
      {
        id: 13,
        title: "Messi Figure",
        price: "₹500",
        category: "miniatures",
        image: messi,
        description: "Detailed Lionel Messi miniature figure.",
        features: ["High detail", "Sports collectible", "Display ready"],
        inStock: true,
      },
      {
        id: 14,
        title: "Doctor Strange Figure",
        price: "₹250",
        category: "miniatures",
        image: Doctorstrange,
        description: "Doctor Strange character figure for collectors.",
        features: ["Marvel collectible", "Detailed finish", "Perfect gift"],
        inStock: true,
      },
      {
        id: 15,
        title: "Chhatrapati Shivaji Maharaj",
        price: "₹600 - ₹800",
        category: "miniatures",
        image: Customizeminiature,
        description: "Historical figure statue with intricate details.",
        features: [
          "Historical accuracy",
          "Premium quality",
          "Collector's item",
        ],
        inStock: true,
      },
      {
        id: 16,
        title: "Sign Board",
        price: "₹80",
        category: "functional",
        image: Signboard,
        description: "Custom sign board for home or office.",
        features: ["Customizable text", "Multiple sizes", "Durable material"],
        inStock: true,
      },
      {
        id: 17,
        title: "SD Card Box",
        price: "₹300",
        category: "functional",
        image: Sdcard,
        description: "Organized storage solution for SD cards.",
        features: ["Multiple slots", "Compact design", "Protective case"],
        inStock: true,
      },
      {
        id: 18,
        title: "NFC Keychain",
        price: "₹100",
        category: "functional",
        image: ins,
        description: "Personalized keychains with custom designs.",
        features: ["Custom text/logo", "Various colors", "Durable material"],
        inStock: true,
      },
      {
        id: 19,
        title: "Blastoise",
        price: "₹100",
        category: "pokemon",
        image: Blastoise,
        description: "Detailed Pokemon model perfect for collectors.",
        features: ["High detail", "Durable material", "Display ready"],
        inStock: true,
      },
      {
        id: 20,
        title: "Customized Keychains",
        price: "₹100",
        category: "functional",
        images: [keychains, ins], // Multiple images for this product
        description: "Personalized keychains with custom designs.",
        features: ["Custom text/logo", "Various colors", "Durable material"],
        inStock: true,
      },
      {
        id: 21,
        title: "Lithopane Photo",
        price: "₹1500",
        category: "custom",
        image: lithopane,
        description:
          "Transform your photos into beautiful 3D printed lithophanes.",
        features: [
          "Custom photo to 3D",
          "Various sizes",
          "Beautiful light effects",
        ],
        inStock: true,
      },

      {
        id: 22,
        title: "Snorlax",
        price: "₹150",
        category: "pokemon", // You can assign e.g. "pokemon"
        image: snorlax,
        description: "3D printed Snorlax, perfect for fans and collectors.",
        features: ["High detail", "Durable resin", "Great gift for fans"],
        inStock: true,
      },
      {
        id: 23,
        title: "Bulbasaur",
        price: "₹150",
        category: "pokemon",
        image: bulbasaur,
        description: "3D printed Bulbasaur planter for nature-loving trainers.",
        features: [
          "Planter-compatible",
          "Cute and sturdy",
          "Collector-friendly",
        ],
        inStock: true,
      },
      {
        id: 24,
        title: "Charmander",
        price: "₹150",
        category: "pokemon",
        image: charmander,
        description: "3D printed Charmander ready to light up your shelf.",
        features: ["Glossy finish", "Mini fire tail", "Showstopper design"],
        inStock: true,
      },
      {
        id: 25,
        title: "Lapras",
        price: "₹150",
        category: "pokemon",
        image: lapras,
        description: "3D printed Lapras, ride the waves in style.",
        features: ["Elegant details", "Ocean-themed", "Unique collectible"],
        inStock: true,
      },
      {
        id: 26,
        title: "Nine Tails",
        price: "₹150",
        category: "pokemon",
        image: nineTails,
        description: "Mystical 3D printed Nine Tails with elegant curves.",
        features: ["Mythical aura", "Intricate tail details", "Premium finish"],
        inStock: true,
      },
      {
        id: 27,
        title: "Pikachu",
        price: "₹150",
        category: "pokemon",
        image: pikachu,
        description: "Everyone's favorite Pokémon in a cute 3D printed form.",
        features: ["Iconic pose", "Great for gifts", "Fan favorite"],
        inStock: true,
      },
      {
        id: 28,
        title: "Deadpool",
        price: "350",
        category: "Marvel",
        image: deadpool,
        description: "3D printed Deadpool with attitude and style.",
        features: [
          "Comic-accurate design",
          "Vibrant colors",
          "Fun display item",
        ],
        inStock: true,
      },
      {
        id: 29,
        title: "Hulk",
        price: "₹500",
        category: "Marvel",
        images: [hulk, hulk_2],
        description: "Smash your collection with this 3D printed Hulk figure.",
        features: ["Strong build", "Detailed muscles", "Bold presence"],
        inStock: true,
      },
      {
        id: 30,
        title: "Jack Sparrow",
        price: "₹650",
        category: "Miniatures",
        image: jackSparrow,
        description: "Captain Jack Sparrow in high-detail 3D print form.",
        features: ["Pirate charm", "Movie-accurate", "Intricate details"],
        inStock: true,
      },
      {
        id: 31,
        title: "Black Panther",
        price: "₹350",
        category: "Marvel", // You can assign e.g. "superhero"
        image: blackPanther,
        description:
          "3D printed Black Panther figure with fierce detail and elegance.",
        features: [
          "Sleek design",
          "Vibrant black finish",
          "Inspired by the Marvel hero",
        ],
        inStock: true,
      },
      {
        id: 32,
        title: "Charmeleon",
        price: "₹150",
        category: "Pokemon",
        image: Charmeleon,
        description: "3D printed Charmeleon with fiery detail and character.",
        features: [
          "Fiery tail design",
          "Anime-accurate model",
          "High quality print",
        ],
        inStock: true,
      },
      {
        id: 33,
        title: "Custom Name Keychain",
        price: "₹70",
        category: "Miniatures",
        image: custom_name_keychain,
        description: "Customizable name keychain perfect for gifting.",
        features: ["Personalized", "Compact size", "Durable material"],
        inStock: true,
      },
      {
        id: 34,
        title: "Dragon",
        price: "₹300",
        category: "DragonBall",
        image: Dragon,
        description: "Majestic dragon figure with detailed wings and scales.",
        features: ["Fantasy themed", "Detailed textures", "Sturdy build"],
        inStock: true,
      },
      {
        id: 35,
        title: "God of War",
        price: "₹700",
        category: "Gaming",
        image: God_of_war,
        description: "Kratos figure from God of War with a powerful stance.",
        features: ["Game-accurate design", "Bold look", "Great for display"],
        inStock: true,
      },
      {
        id: 36,
        title: "Goku",
        price: "₹500",
        category: "DragonBall",
        image: Goku,
        description: "3D printed Goku in iconic battle-ready pose.",
        features: ["Saiyan armor", "Dynamic stance", "Dragon Ball inspired"],
        inStock: true,
      },
      {
        id: 37,
        title: "Loki",
        price: "₹350",
        category: "Marvel",
        image: Loki,
        description: "Loki figure with signature horns and mischief.",
        features: [
          "Detailed horns",
          "Green and gold finish",
          "Marvel Universe",
        ],
        inStock: true,
      },
      {
        id: 38,
        title: "Majin Buu",
        price: "₹500",
        category: "DragonBall",
        image: Majinboo,
        description: "Cute yet menacing Majin Buu from Dragon Ball Z.",
        features: ["Soft pink color", "Chibi style", "Collector's favorite"],
        inStock: true,
      },
      {
        id: 39,
        title: "Naruto",
        price: "₹900",
        category: "Miniatures",
        image: Naruto,
        description: "Iconic Naruto figure with ninja headband and pose.",
        features: ["Ninja pose", "Great detailing", "Anime accurate"],
        inStock: true,
      },
      {
        id: 40,
        title: "Psyduck",
        price: "₹150",
        category: "Pokemon",
        image: Psyduck,
        description: "Confused yet adorable Psyduck with comic expression.",
        features: ["Funny design", "Cute expression", "Smooth finish"],
        inStock: true,
      },
      {
        id: 41,
        title: "Ronaldo",
        price: "₹550",
        category: "Miniatures",
        image: Ronaldo,
        description: "Cristiano Ronaldo figure capturing his iconic pose.",
        features: ["Football star", "Great for fans", "Realistic model"],
        inStock: true,
      },
      {
        id: 42,
        title: "Spiderman",
        price: "₹450",
        category: "Marvel",
        image: Spiderman,
        description: "Dynamic Spiderman figure ready to swing into action.",
        features: ["Web-slinging pose", "Red-blue suit", "Marvel classic"],
        inStock: true,
      },
      {
        id: 43,
        title: "Stitch",
        price: "₹300",
        category: "Miniatures",
        image: Stitch,
        description: "Cute and mischievous Stitch from Lilo & Stitch.",
        features: ["Adorable alien", "Vibrant colors", "Disney charm"],
        inStock: true,
      },
      {
        id: 44,
        title: "Superman",
        price: "₹550",
        category: "Marvel",
        image: Superman,
        description: "Superman in heroic flying pose with cape flowing.",
        features: ["Strong pose", "Iconic 'S' logo", "DC superhero"],
        inStock: true,
      },
      {
        id: 45,
        title: "Thor",
        price: "₹700",
        category: "Marvel",
        image: Thor,
        description: "God of Thunder with Mjölnir in battle stance.",
        features: ["Lightning-themed", "Detailed armor", "Marvel god"],
        inStock: true,
      },
      {
        id: 46,
        title: "Vegeta",
        price: "₹500",
        category: "DragonBall",
        image: Vegeta,
        description: "Prince of Saiyans Vegeta ready for a fight.",
        features: ["Muscular design", "Classic armor", "DBZ favorite"],
        inStock: true,
      },
      {
        id: 47,
        title: "Card Holder",
        price: "₹650",
        category: "functional",
        image: card_holder,
        description:
          "Minimalist 3D printed card holder for your desk or wallet.",
        features: ["Compact design", "Durable print", "Stylish utility"],
        inStock: true,
      },
    ];

    setProducts(productsData);
    setLoading(false);

    // Load cart from localStorage on initial render
    try {
      const savedCart = localStorage.getItem("printTechCart");
      if (savedCart) {
        setCart(JSON.parse(savedCart));
      }
    } catch (error) {
      console.error("Error loading cart:", error);
    }
  }, []);

  // Reset visible products when category or sort changes
  useEffect(() => {
    setVisibleProducts(6);
  }, [activeCategory, sortBy]);

  // Filter and sort products
  const getFilteredAndSortedProducts = () => {
    let filteredProducts = products;

    // Apply category filter
    if (activeCategory !== "all") {
      filteredProducts = products.filter(
        (product) => product.category === activeCategory
      );
    }

    // Apply sorting
    switch (sortBy) {
      case "price-low":
        return [...filteredProducts].sort((a, b) => {
          const priceA = parseFloat(a.price.replace(/[^0-9.-]+/g, ""));
          const priceB = parseFloat(b.price.replace(/[^0-9.-]+/g, ""));
          return priceA - priceB;
        });
      case "price-high":
        return [...filteredProducts].sort((a, b) => {
          const priceA = parseFloat(a.price.replace(/[^0-9.-]+/g, ""));
          const priceB = parseFloat(b.price.replace(/[^0-9.-]+/g, ""));
          return priceB - priceA;
        });
      case "newest":
        return [...filteredProducts].reverse();
      default:
        return filteredProducts;
    }
  };

  const handleLoadMore = () => {
    setVisibleProducts((prevVisible) => prevVisible + PRODUCTS_PER_LOAD);
  };

  const handleAddToCart = (product) => {
    const productWithQuantity = { ...product, quantity: 1 };
    let currentCart = [...cart];

    const existingItemIndex = currentCart.findIndex(
      (item) => item.id === product.id
    );

    if (existingItemIndex >= 0) {
      currentCart[existingItemIndex].quantity += 1;
    } else {
      currentCart.push(productWithQuantity);
    }

    localStorage.setItem("printTechCart", JSON.stringify(currentCart));
    setCart(currentCart);

    // Show toast notification
    showToast(`${product.title} added to cart!`);
  };

  const handleBuyNow = (product) => {
    const message = `Hello! I'm interested in purchasing "${product.title}" (${product.price}). Please provide more information.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleGetQuote = () => {
    const message = `I would like to get a quote for a custom 3D printing project`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleTryNow = () => {
    window.open("/process", "_blank");
  };

  // Toast notification function
  const showToast = (message) => {
    // Create toast element
    const toast = document.createElement("div");
    toast.className =
      "fixed bottom-4 right-4 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-slide-up";
    toast.textContent = message;
    document.body.appendChild(toast);

    // Remove after 3 seconds
    setTimeout(() => {
      toast.classList.add("animate-fade-out");
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-red-600"></div>
      </div>
    );
  }

  const filteredAndSortedProducts = getFilteredAndSortedProducts();
  const productsToShow = filteredAndSortedProducts.slice(0, visibleProducts);
  const hasMoreProducts = visibleProducts < filteredAndSortedProducts.length;

  return (
    <div className="pb-16 bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <ProductHero />

      {/* Cart Summary Notification */}
      {cart.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 mt-4">
          <div className="bg-gradient-to-r from-gray-900 to-red-900 rounded-xl p-3 text-white shadow-lg">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="bg-white/10 p-2 rounded-full hidden sm:block">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div className="sm:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-sm font-bold">
                    {cart.length} item(s) in your cart
                  </h2>
                  <p className="text-xs text-gray-300">
                    Total: ₹
                    {cart.reduce((total, item) => {
                      const price = parseFloat(
                        item.price.replace(/[^0-9.-]+/g, "")
                      );
                      return total + price * item.quantity;
                    }, 0)}
                  </p>
                </div>
              </div>
              <Link
                to="/cart"
                className="px-4 py-1.5 bg-red-600 text-white rounded-full text-sm font-bold hover:bg-red-700 transition-colors sm:bg-white sm:text-red-700 sm:hover:bg-gray-100"
              >
                View Cart
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Product Filters */}
        <ProductFilters
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          sortBy={sortBy}
          onSortChange={setSortBy}
        />

        {/* Products Grid - Optimized Layout */}
        <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6 lg:gap-8 mb-8">
          {productsToShow.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={handleAddToCart}
              onBuyNow={handleBuyNow}
            />
          ))}
        </div>

        {/* Load More Button */}
        {hasMoreProducts && (
          <div className="flex justify-center mb-16">
            <button
              onClick={handleLoadMore}
              className="px-8 py-3 bg-gradient-to-r from-gray-900 to-red-900 text-white rounded-full font-semibold hover:from-red-900 hover:to-gray-900 transition-all duration-300 flex items-center gap-2 shadow-lg"
            >
              <span>Load More</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
        )}

        {/* No Products Found */}
        {filteredAndSortedProducts.length === 0 && (
          <div className="text-center py-16">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 mx-auto text-gray-400 mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              No products found
            </h3>
            <p className="text-gray-500 mb-6">
              Try selecting a different category or adjusting your filters.
            </p>
            <button
              onClick={() => setActiveCategory("all")}
              className="px-6 py-2 bg-red-600 text-white rounded-full font-medium hover:bg-red-700 transition-colors"
            >
              Clear Filters
            </button>
          </div>
        )}

        {/* Process Section */}
        <ProcessSection onTryNow={handleTryNow} />

        {/* CTA Section */}
        <CTASection onGetQuote={handleGetQuote} />
      </div>

      {/* Footer */}
      <Footer />

      {/* Toast Styles */}
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        @keyframes slideDown {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        
        .animate-slide-up {
          animation: slideUp 0.3s ease-out forwards;
        }
        
        .animate-slide-down {
          animation: slideDown 0.3s ease-out forwards;
        }
        
        .animate-fade-out {
          animation: fadeOut 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Products;
